import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ButtonComponent } from '../../button/button.component';
import { ModalLayoutComponent } from '../modal-layout/modal-layout.component';

export interface RequestSubmittedModalData {
  businessName?: string;
  policyNumber?: string;
}

@Component({
  selector: 'lib-request-submitted',
  imports: [ModalLayoutComponent, ButtonComponent],
  templateUrl: './request-submitted.component.html',
  styleUrl: './request-submitted.component.scss'
})
export class RequestSubmittedComponent {
  data = inject(MAT_DIALOG_DATA) as RequestSubmittedModalData;
  dialogRef = inject(MatDialogRef<RequestSubmittedComponent>);

  closeModal() {
    this.dialogRef.close();
  }
}
